<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent"><a id="file_036"><strong>4.</strong> Lay the wings on the back of the bumblebee and needle to attach.</a></p><a id="file_036">
<p class="image"><img alt="Image" src="images/f0014-05.jpg"/></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// file_036.vue?04672a06